import React, { useMemo, useState } from 'react';
import ContentBody from '@/pages/opinion/components/ContentBody';
import { Col, Layout, Row } from 'tea-component';
import { connect, getLocale, useIntl } from 'umi';
import { FilterFixed, useFilterDataHook } from '@op/components/FilterCommon';
import moment from 'moment';
import CardLoading from '@op/components/CardLoading';
import FilteredInfluencer from './FilteredInfluencer';
import LanguageChart from './LanguageChart';
import InfluencerList from './InfluencerList';
import '@op/assets/scss/pages/community/influencer.scss';
import './index.scss';
import { useInitBuriedPointInfo } from '@op/operationLog/buriedPoint';
import influencerGenreCreatorList from '@op/operationLog/pages/influencerGenreCreatorList';
import { PAGE_NAME } from '@op/constants/page';
import BubbleCommon, {
  communityInfluencerGenreCreatorListTitleText,
} from '@op/components/BubbleCommon';
import { DBO_TM } from '@op/utils/format';
import { useRequestFontWebConfig } from '@op/hooks/useFrontWebConfig';

const { Content } = Layout;

function GenreCreatorList({ gameInfo }: any) {
  useInitBuriedPointInfo({ buriedPoint: influencerGenreCreatorList });
  const { formatMessage } = useIntl();
  const [userSynchronousValue, setUserSynchronousValue] = useState({});

  const { loading, changeFilter, filter, scrollBody, filterOptions } =
    useFilterDataHook({
      pageName: 'GenreCreatorList',
    });

  const isEN = getLocale() === 'en-US';
  const { kol_tags_genre_options = [], loading: fontWebLoading } = useRequestFontWebConfig({ keys: [{ key: 'kol_tags_genre_options' }], gameInfo });
  const genreCreatorListTagsList = useMemo(() => {
    return kol_tags_genre_options.map((val) => {
      const textEN = val?.text || val?.textCN;
      const textCN = val?.textCN || val?.text;
      const text = isEN ? textEN : textCN;
      return {
        ...val,
        text,
        key: val?.value,
        downloadText: textEN,
        bgColor: val?.background
      };
    })
  }, [isEN, kol_tags_genre_options]);

  return (
    <Content className="dbo-page dbo-genre-creator-list">
      <Content.Header
        title={formatMessage({ id: PAGE_NAME.GENRE_CREATOR_LIST })}
        operation={
          <span style={{ fontSize: 12, color: '#707070' }}>
            <BubbleCommon
              iconStyle={{ marginLeft: 5 }}
              tipsMap={communityInfluencerGenreCreatorListTitleText}
            >
              {formatMessage({ id: 'Data Update' })}
            </BubbleCommon>
          </span>
        }
      />
      <ContentBody pageName={PAGE_NAME.GENRE_CREATOR_LIST}>
        <FilterFixed
          filter={filterOptions}
          operateShowOptions={['history', 'save', 'more']}
          defaultConfig={{
            channel: { channelKey: 'social' },
            date: {
              dateTypeList: ['date'],
              permanentTipsKey: 'influencer',
              rangePrefixMap: {
                'en-US': 'Publication Date',
                'zh-CN': '发帖时间',
              },
              setShortcutOption: (values) => {
                const { date, ...otherInfo } = values;
                return {
                  ...otherInfo,
                  date: date.filter((item) => {
                    return ![
                      'Last 365 Days',
                      'All of time',
                      'Year to Date',
                    ].includes(item.name);
                  }),
                };
              },
            },
            regionAndLanguage: {
              regionTipsKey: 'influencer',
              languageTipsKey: 'influencer',
              regionGolobalTipsKey: 'influencer',
            },
            group: { isBrandPage: true },
          }}
          historyConfig={{ fixFilter: { date_type: 'daily' } }}
          defaultValue={DBO_TM.utcFilterRangeDay(89, 0)}
          finallyDealwithDefaultValue={(value) => {
            const { date_type, ...otherProps } = value;
            return { ...otherProps, date_type: 'daily' };
          }}
          confirm={(value?: any) => {
            let { language, ...otherValue } = value;
            changeFilter({
              ...gameInfo,
              ...otherValue,
              languages: language,
            });
          }}
        ></FilterFixed>
        <CardLoading loading={loading || fontWebLoading}>
          <Row gap={20} style={{ marginBottom: 10 }}>
            <Col span={12}>
              <FilteredInfluencer filter={filter} genreCreatorListTagsList={genreCreatorListTagsList}></FilteredInfluencer>
            </Col>
            <Col span={12}>
              <LanguageChart
                setUserSynchronousValue={setUserSynchronousValue}
                filter={filter}
              ></LanguageChart>
            </Col>
          </Row>
          <InfluencerList
            userSynchronousValue={userSynchronousValue}
            filter={filter}
            gameInfo={gameInfo}
            tagList={genreCreatorListTagsList}
          ></InfluencerList>
        </CardLoading>
      </ContentBody>
    </Content>
  );
}

export default connect((state: { opinionCommon: any }) => {
  const { opinionCommon } = state;
  return {
    gameInfo: opinionCommon.gameInfo,
    wholeGameInfo: opinionCommon.wholeGameInfo,
  };
})(GenreCreatorList);
